import { CollectPanel } from './collectPanel.tsx';
import { CommentPanel } from './commentPanel.tsx';
import { ProductInfoPanel } from './productInfoPanel.tsx';
import { EquipmentOption, SelectedPart } from './types.ts';


interface Props {
    selectedEquipment: EquipmentOption | null;
    selectedPart: SelectedPart | null;
}

export function MiscInfoBar({
    selectedEquipment,
    selectedPart,
}: Props) {

    return (
        <div className='flex--horz' style={{ marginTop: '8px' }}>
            <CommentPanel
                style={{ flexGrow: 1, flexBasis: 0, minWidth: 0 }}
                selectedEquipment={selectedEquipment}
                selectedPart={selectedPart}
            />
            <ProductInfoPanel
                style={{ marginLeft: '24px' }}
                selectedEquipment={selectedEquipment}
                selectedPart={selectedPart}
            />
            {(selectedEquipment == null || selectedEquipment.type === 'cnc') &&
                <CollectPanel
                    selectedEquipment={selectedEquipment}
                />
            }
        </div>
    );
}
